/* ============================================================
 * ORIMONO cookie consent  ->  Shopify Customer Privacy API
 *                         ->  Google Consent Mode v2
 *
 * Works with the existing banner markup in sections/footer.liquid
 * (.store-cookies bar + #cookiePopup modal). Look and text unchanged.
 *
 * Must load AFTER global.js (both defer). The old handler in global.js
 * is neutralised without editing it:
 *   - clicks on .acceptAll / .acceptSelected are intercepted in the
 *     capture phase on document, so global.js's button listeners never run;
 *   - global.js's "show bar if nothing in localStorage" is undone in our
 *     DOMContentLoaded handler (registered later, so it runs later, same
 *     task, no flash) and replaced by region-aware logic.
 * .customiseCookies and .modal-close are still handled by global.js.
 *
 * localStorage key `cookieConsent` keeps its old shape for compatibility:
 *   { strictly_required, analytics, marketing, functional } (+ updated_at)
 * ============================================================ */
(function () {
  'use strict';

  if (window.ORIMONO_CONSENT_MANAGED) return;
  window.ORIMONO_CONSENT_MANAGED = true; // guard flag

  var STORAGE_KEY = 'cookieConsent';
  var API_TIMEOUT_MS = 4000;
  // EEA + UK + CH: always ask here, even if Shopify's own region config says no.
  var CONSENT_COUNTRIES = ('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE ' +
    'IS LI NO GB CH').split(' ');

  var apiReady = false;
  var apiFailed = false;
  var apiQueue = [];

  /* ---------- storage ---------- */
  function readStored() {
    try {
      var p = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return p && typeof p === 'object' ? p : null;
    } catch (e) {
      return null;
    }
  }

  function writeStored(prefs) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        strictly_required: true,
        analytics: !!prefs.analytics,
        marketing: !!prefs.marketing,
        functional: !!prefs.functional,
        updated_at: new Date().toISOString()
      }));
    } catch (e) {}
  }

  /* ---------- Google Consent Mode v2 ---------- */
  function g(v) { return v ? 'granted' : 'denied'; }

  function gtagUpdate(prefs) {
    window.dataLayer = window.dataLayer || [];
    var gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    gtag('consent', 'update', {
      ad_storage: g(prefs.marketing),
      ad_user_data: g(prefs.marketing),
      ad_personalization: g(prefs.marketing),
      analytics_storage: g(prefs.analytics),
      functionality_storage: g(prefs.functional),
      personalization_storage: g(prefs.functional)
    });
  }

  /* ---------- Shopify Customer Privacy API ---------- */
  function cp() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function withApi(fn) {
    if (apiReady) return fn(cp());
    if (!apiFailed) apiQueue.push(fn);
  }

  function shopifySet(prefs) {
    withApi(function (api) {
      api.setTrackingConsent({
        analytics: !!prefs.analytics,
        marketing: !!prefs.marketing,
        preferences: !!prefs.functional,
        sale_of_data: !!prefs.marketing
      }, function (res) {
        if (res && res.error) console.warn('[consent] setTrackingConsent failed', res.error);
      });
    });
  }

  function yn(v) { return v ? 'yes' : 'no'; }

  function needsBanner(api) {
    try {
      if (typeof api.shouldShowBanner === 'function' && api.shouldShowBanner()) return true;
    } catch (e) {}
    var region = '';
    try { region = typeof api.getRegion === 'function' ? (api.getRegion() || '') : ''; } catch (e) {}
    if (!region) return true; // unknown location: ask (fail safe)
    return CONSENT_COUNTRIES.indexOf(region.slice(0, 2).toUpperCase()) !== -1;
  }

  /* ---------- UI ---------- */
  function els() {
    return {
      bar: document.querySelector('.store-cookies'),
      popup: document.querySelector('#cookiePopup'),
      analytics: document.querySelectorAll('.cookie-checkbox.analytics'),
      marketing: document.querySelectorAll('.cookie-checkbox.marketing'),
      functional: document.querySelectorAll('.cookie-checkbox.functional'),
      strict: document.querySelectorAll('.cookie-checkbox.strictly_required')
    };
  }

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function syncCheckboxes(prefs) {
    var e = els();
    each(e.analytics, function (el) { el.checked = !!(prefs && prefs.analytics); });
    each(e.marketing, function (el) { el.checked = !!(prefs && prefs.marketing); });
    each(e.functional, function (el) { el.checked = !!(prefs && prefs.functional); });
    each(e.strict, function (el) { el.checked = true; el.disabled = true; });
  }

  function hideBanner() {
    var e = els();
    if (e.bar) e.bar.classList.remove('active');
    if (e.popup) e.popup.classList.remove('active');
  }

  function showBar() {
    var e = els();
    if (e.bar) e.bar.classList.add('active');
  }

  // Same toast as the original global.js implementation
  function showConfirmation(message) {
    var toast = document.createElement('div');
    toast.textContent = message;
    toast.style.position = 'fixed';
    toast.style.bottom = '25px';
    toast.style.right = '25px';
    toast.style.background = '#333';
    toast.style.color = '#fff';
    toast.style.padding = '10px 18px';
    toast.style.borderRadius = '6px';
    toast.style.fontSize = '14px';
    toast.style.zIndex = '9999';
    toast.style.opacity = '0';
    toast.style.transition = 'opacity 0.3s ease';
    document.body.appendChild(toast);
    setTimeout(function () { toast.style.opacity = '1'; }, 100);
    setTimeout(function () {
      toast.style.opacity = '0';
      setTimeout(function () { toast.remove(); }, 300);
    }, 2500);
  }

  function applyChoice(prefs, message) {
    writeStored(prefs);
    syncCheckboxes(prefs);
    gtagUpdate(prefs);
    shopifySet(prefs);
    hideBanner();
    showConfirmation(message);
  }

  /* ---------- click handling (capture phase: runs before global.js listeners) ---------- */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.acceptAll, .acceptSelected');
    if (!btn) return;

    ev.preventDefault();
    ev.stopPropagation(); // keeps the event from reaching global.js's button listeners

    if (btn.classList.contains('acceptAll')) {
      applyChoice({ analytics: true, marketing: true, functional: true }, 'All cookies have been accepted.');
      return;
    }

    if (btn.closest('.store-cookies')) {
      // Bar button "ALLOW ESSENTIAL" = reject everything non-essential
      applyChoice({ analytics: false, marketing: false, functional: false }, 'Your cookie preferences have been saved.');
      return;
    }

    // Popup / Cookie Preferences page "ACCEPT SELECTED" = save the boxes ticked next to THIS button
    // (live-match 22 Oct: the page and the popup both exist on /pages/cookie-preferences; read the right set)
    var scope = btn.closest('#cookiePopup') || btn.closest('.shopify-section') || document;
    function ticked(cls) {
      var el = scope.querySelector('.cookie-checkbox.' + cls) || document.querySelector('.cookie-checkbox.' + cls);
      return !!(el && el.checked);
    }
    applyChoice({
      analytics: ticked('analytics'),
      marketing: ticked('marketing'),
      functional: ticked('functional')
    }, 'Your cookie preferences have been saved.');
  }, true);

  // Keep Google in step with consent changes made elsewhere (checkout, other apps)
  document.addEventListener('visitorConsentCollected', function (ev) {
    var d = ev && ev.detail;
    if (!d) return;
    var prefs = { analytics: !!d.analyticsAllowed, marketing: !!d.marketingAllowed, functional: !!d.preferencesAllowed };
    writeStored(prefs); // keep localStorage in step so a stale choice cannot override this one later
    syncCheckboxes(prefs);
    gtagUpdate(prefs);
  });

  /* ---------- init ---------- */
  function decide(api) {
    var stored = readStored();

    if (stored) {
      var cur = {};
      try { cur = api.currentVisitorConsent() || {}; } catch (e) {}
      var differs = cur.analytics !== yn(stored.analytics) ||
          cur.marketing !== yn(stored.marketing) ||
          cur.preferences !== yn(stored.functional);
      var shopifyHas = ['analytics', 'marketing', 'preferences'].some(function (k) {
        return cur[k] === 'yes' || cur[k] === 'no';
      });
      if (differs && shopifyHas) {
        // Shopify holds a newer decision (e.g. changed at checkout or in another app): it wins
        var sp = { analytics: cur.analytics === 'yes', marketing: cur.marketing === 'yes', functional: cur.preferences === 'yes' };
        writeStored(sp);
        syncCheckboxes(sp);
        gtagUpdate(sp);
        hideBanner();
        return;
      }
      // Shopify has no decision (e.g. its cookie expired): re-send the stored one
      if (differs) shopifySet(stored);
      gtagUpdate(stored);
      hideBanner();
      return;
    }

    var c = {};
    try { c = api.currentVisitorConsent() || {}; } catch (e) {}
    if (c.analytics || c.marketing || c.preferences) {
      // Shopify already has a decision (e.g. given earlier / at checkout): adopt it
      var prefs = { analytics: c.analytics === 'yes', marketing: c.marketing === 'yes', functional: c.preferences === 'yes' };
      writeStored(prefs);
      syncCheckboxes(prefs);
      gtagUpdate(prefs);
      hideBanner();
      return;
    }

    if (needsBanner(api)) {
      showBar();
      return;
    }

    // No banner required in this region: follow Shopify's defaults for Google too
    hideBanner();
    try {
      gtagUpdate({
        analytics: api.analyticsProcessingAllowed(),
        marketing: api.marketingAllowed(),
        functional: api.preferencesProcessingAllowed()
      });
    } catch (e) {}
  }

  function fallback() {
    // API unavailable: behave like the old banner (show if nothing stored)
    var stored = readStored();
    if (stored) {
      gtagUpdate(stored);
      hideBanner();
    } else {
      showBar();
    }
  }

  function loadApi() {
    var done = false;
    var timer = setTimeout(function () {
      if (done) return;
      done = true;
      apiFailed = true;
      apiQueue = [];
      console.warn('[consent] Customer Privacy API did not load in time');
      fallback();
    }, API_TIMEOUT_MS);

    function ready() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      apiReady = true;
      var api = cp();
      decide(api);
      var q = apiQueue; apiQueue = [];
      q.forEach(function (fn) { try { fn(api); } catch (e) {} });
    }

    if (cp() && typeof cp().setTrackingConsent === 'function') return ready();

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      clearTimeout(timer);
      done = true;
      apiFailed = true;
      return fallback();
    }

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
      if (error || !cp()) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        apiFailed = true;
        apiQueue = [];
        console.warn('[consent] loadFeatures error', error);
        return fallback();
      }
      ready();
    });
  }

  function init() {
    // Undo global.js's unconditional "show if nothing stored"; we decide below.
    var e = els();
    if (e.bar) e.bar.classList.remove('active');
    syncCheckboxes(readStored());
    loadApi();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
